export default "__VITE_ASSET__90626bcc__"